"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dIdentityTransform = void 0;
const a_cartesian2d_user_transform_1 = require("./a-cartesian2d-user-transform");
const e_cartesian2d_user_transform_1 = require("./e-cartesian2d-user-transform");
/**
 * @public
 * Apply no transform.
 */
class Cartesian2dIdentityTransform extends a_cartesian2d_user_transform_1.ACartesian2dUserTransform {
    constructor() {
        super(...arguments);
        this.transformId = e_cartesian2d_user_transform_1.ECartesian2dUserTransform.Identity;
        this.xTransformEnabled = true;
        this.yTransformEnabled = true;
        this.userTransformId = Cartesian2dIdentityTransform.transformId;
    }
    forwardX(x) {
        return x;
    }
    forwardY(y) {
        return y;
    }
    reverseX(x) {
        return x;
    }
    reverseY(y) {
        return y;
    }
}
exports.Cartesian2dIdentityTransform = Cartesian2dIdentityTransform;
Cartesian2dIdentityTransform.transformId = Symbol("identity");
//# sourceMappingURL=cartesian2d-identity-transform.js.map